import { Tooltip } from "./Tooltip";
import { TooltipInterface, ClickTooltipConfiguration } from "../entity";
import { DomEvent } from "../../dom";
import { DOMElementEvent } from "../../dom/DOMElementEvent.enum";
import { TooltipPosition } from "../entity/TooltipPosition";

export class ClickTooltip extends Tooltip implements TooltipInterface {

    private fadeoutClass = 'fade-out';

    constructor(protected configuration: ClickTooltipConfiguration,) {
        super(configuration);

        if (configuration.onCursor) {
            setTimeout(() => this.centerTooltip());
        }

        this.handlePreviousTooltipRemoval();
    }

    public append() {
        this.configuration.parentElement.appendChild(this.tooltip);
        this.setupFadeTimer();
        this.setupClickListener();
    }

    public remove() {
        this.tooltip.addEventListener(DomEvent.TransitionEnd, () => {
            this.configuration.parentElement.removeChild(this.tooltip);
        });

        this.tooltip.classList.add(this.fadeoutClass);
    }

    private setupFadeTimer() {
        if (!this.configuration.fadeAfter) {
            return;
        }

        setTimeout(() => {
            this.remove();
        }, this.configuration.fadeAfter);
    }

    private setupClickListener() {
        this.tooltip.addEventListener(DOMElementEvent.Click, () => {
            this.remove();
        });
    }

    private centerTooltip(): void {
        if (!this.configuration.domEvent) {
            return;
        }

        const clickEvent = this.configuration.domEvent as CustomEvent;
        const rect = this.tooltip.getBoundingClientRect();

        const tooltipPosition = new TooltipPosition(clickEvent, rect);

        this.tooltip.style.top = tooltipPosition.getTopPosition();
        this.tooltip.style.left = tooltipPosition.getLeftPosition();
    }

    private handlePreviousTooltipRemoval() {
        const previousTooltip = document.querySelector(`.${this.configuration.cssClass}`);

        if (previousTooltip && previousTooltip.parentElement) {
            previousTooltip.parentElement.removeChild(previousTooltip);
        }
    }

}
